import { IMAGE_CACHE_STATE } from "../offline/imageCache"
import { useMenuData } from "../offline/menuData"
import { downloadFraction, downloadLabel, photosLabel } from "../models/syncStatus"
import Loader from "./Loader"
import "./FirstSyncPanel.css"

// The very first sync on a device: the whole menu downloads, then its photos are saved.
export default function FirstSyncPanel({ onDismiss }) {
  const { menu, sync, imageProgress } = useMenuData()
  const hasMenu = Boolean(menu)

  return (
    <div className="first-sync" role="status" aria-live="polite">
      <div className="first-sync__card">
        <h2 className="first-sync__title">Setting up the menu</h2>
        <p className="first-sync__body">
          The whole menu is saved to this device, so it keeps working without a connection.
        </p>

        <div className="first-sync__loader">
          <Loader label="Setting up the menu" />
        </div>

        <Step
          label="Menu"
          value={hasMenu ? "Saved" : downloadLabel(sync.progress)}
          fraction={hasMenu ? 1 : downloadFraction(sync.progress)}
          isActive={!hasMenu}
        />
        <Step
          label="Photos"
          value={hasMenu ? photosLabel(imageProgress) : "Waiting for the menu"}
          fraction={hasMenu ? fractionOf(imageProgress.saved, imageProgress.total) : 0}
          isActive={hasMenu && imageProgress.state === IMAGE_CACHE_STATE.SAVING}
        />

        {hasMenu && (
          <button type="button" className="first-sync__dismiss" onClick={onDismiss}>
            Browse the menu
          </button>
        )}
      </div>
    </div>
  )
}

// One stage: its label, how far it has got, and a bar that goes striped when the size is unknown.
function Step({ label, value, fraction, isActive }) {
  const isUnknown = fraction === null
  return (
    <div className={`first-sync__step${isActive ? " first-sync__step--active" : ""}`}>
      <div className="first-sync__step-row">
        <span className="first-sync__step-label">{label}</span>
        <span className="first-sync__step-value">{value}</span>
      </div>
      <span className={`first-sync__bar${isUnknown && isActive ? " first-sync__bar--unknown" : ""}`}>
        <span
          className="first-sync__bar-fill"
          style={{ width: `${Math.round((isUnknown ? 0 : fraction) * 100)}%` }}
        />
      </span>
    </div>
  )
}

function fractionOf(done, total) {
  if (!total) return null
  return Math.min(1, Math.max(0, done / total))
}
